import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import logo from "../../Assets/images/exbitlogo.webp";

import "./header.css";

const Header = () => {
  const [showNavbar, setShowNavbar] = useState(false);
  const [showHamburger, setHamburger] = useState(false);
  const [DefiPrice, setDefiPrice] = useState();

  const Price = async () => {
    try {
      const response = await fetch("https://gapi.ex-bit.ai/exbit/price");
      const json = await response.json();
      setDefiPrice(json.price);
    } catch (error) {
      console.log(error);
    }
  };

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
    setHamburger(!showHamburger);
  };

  useEffect(() => {
    Price();
    const interval = setInterval(() => {
      Price();
    }, 3000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setShowNavbar(false);
        setHamburger(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <header className={`${showNavbar ? "openmenu" : ""}`}>
        <div className="container mx-auto mt-2 ">
          <div className=" items-center flex justify-between">
            <div className=" text-start">
              <div className="logo">
                <img src={logo} height={18} width={18} alt="logo" className="block w-18 h-auto" />
            
              </div>
            </div>
            {/* <div className={` text-center hidden md:block position-relative`}>
              <ul className="menu list-unstyled m-0 p-0 flex space-x-4">
                <li>
                  <Link to="aboutusSrl" smooth={true} duration={0} className="cursor-pointer">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="advantagesSrl" smooth={true} duration={0} className="cursor-pointer">
                    Advantages
                  </Link>
                </li>
                <li>
                  <Link to="tokenomicsSrl" smooth={true} duration={0} className="cursor-pointer">
                    Tokenomics
                  </Link>
                </li>
                <li>
                  <Link to="roadmapSrl" smooth={true} duration={0} className="cursor-pointer">
                    Roadmap
                  </Link>
                </li>
                <li>
                  <Link to="faqsSrl" smooth={true} duration={0} className="cursor-pointer">
                    Faqs
                  </Link>
                </li>
              </ul>
            </div> */}
            <div className="text-end">
              <div className="rightboxmenu">
              <div className="bnrbtn t">
                  <button className=" max-w-52 w-full flex justify-center   px-5 py-3 relative   border-white rounded-lg  bg-gradient-to-b from-blue-500 to-custom-dark-end">
                    Price: ${DefiPrice}
                  </button>
                  </div>
                {/* <div
                  className={`hamburger md:hidden ${showHamburger ? "is-active" : ""}`}
                  onClick={handleShowNavbar}
                >
                  <span className="line"></span>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </header>
        {/* <div className={`menubar ${showNavbar ? "mobileMenu" : ""}`}>
          <ul className="menu list-unstyled m-0 p-0">
            <li>
              <Link to="aboutusSrl" smooth={true} duration={0} onClick={handleShowNavbar} className="cursor-pointer">
                About Us
              </Link>
            </li>
            <li>
              <Link to="advantagesSrl" smooth={true} duration={0} onClick={handleShowNavbar} className="cursor-pointer">
                Advantages
              </Link>
            </li>
            <li>
              <Link to="tokenomicsSrl" smooth={true} duration={0} onClick={handleShowNavbar} className="cursor-pointer">
                Tokenomics
              </Link>
            </li>
            <li>
              <Link to="roadmapSrl" smooth={true} duration={0} onClick={handleShowNavbar} className="cursor-pointer">
                Roadmap
              </Link>
            </li>
            <li>
              <Link to="faqsSrl" smooth={true} duration={0} onClick={handleShowNavbar} className="cursor-pointer">
                Faqs
              </Link>
            </li>
          </ul>
        </div> */}
    </>
  );
};

export default Header;
